import { LocalPoi } from '../interface/LocalPoi';

export type ClusterProperties = {
  cluster: true;
  cluster_id: number;
  point_count: number;
  point_count_abbreviated: string;
  color: string;
};

export type PoiProperties = {
  cluster?: false;
  poi: LocalPoi;
  categoryId: number;
};

export type ClusterFeature = {
  type: 'Feature';
  geometry: {
    type: 'Point';
    coordinates: [number, number];
  };
  properties: ClusterProperties | PoiProperties;
};

export function isCluster(
  properties: ClusterProperties | PoiProperties
): properties is ClusterProperties {
  return !!properties.cluster;
}
